import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { CANJE } from 'src/app/shared/constantes/constants';
import { CanjeMedico } from 'src/app/models/canje-medico';
import { AdministradorService } from 'src/app/services/administrador.service';
import { Paginar } from 'src/app/models/http-paginacion.interface';

@Component({
  selector: 'app-administrador-notificaciones-canje-medicos',
  templateUrl: './administrador-notificaciones-canje-medicos.component.html',
  styleUrls: ['./administrador-notificaciones-canje-medicos.component.scss']
})
export class AdministradorNotificacionesCanjeMedicosComponent {
  canjeMedicos: CanjeMedico[] = []
  statusCanje: string[] = [...CANJE];
  currentPage: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItems: number = 10;

  constructor(private administradorService: AdministradorService) {
    this.getCanjesMedicos();
  }

  get totalPaginas(): number {
    return Math.ceil(this.canjeMedicos.length / this.currentPage.rows);
  }

  get paginacionCanjesMedicos(): CanjeMedico[] {
    const startIndex = (this.currentPage.page) * this.currentPage.rows;
    return this.canjeMedicos.slice(startIndex, startIndex + this.currentPage.rows);
  }

  getCanjesMedicos(): void {
    this.administradorService.notificacionesCanjesMedicos()
      .subscribe({
        next: (resp) => {
          this.canjeMedicos = resp.datos
          this.totalItems = resp.datos.length;
        },
        error: (err: HttpErrorResponse) => { console.log(err.error.message) },
        complete: () => { }
      })
  }

  getCanje(id: number): string {
    return this.statusCanje[id];
  }

  onPageChange(event: any) {
    this.currentPage = <Paginar>event;
  }

  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const canjesMedicos = this.fullNotificacionesMedicos();
    const titulo = [{ campo: "Canjes de Medicos ", fecha: new Date().toLocaleDateString() }];
    const fileName = 'canjes-medicos';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, titulo, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, canjesMedicos, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'canjes-medicos');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  fullNotificacionesMedicos() {
    const saldoEnfermeras = this.canjeMedicos.map((item) => { return { "Fecha": item.fechaInicio, Medico: item.medico.nom_medico, "Canje": item.redimir, "Estatus": this.getCanje(item.status) } });
    return saldoEnfermeras;
  }
}
